import { AutoScrollSettings } from '../../../pages/display/AutoScrollOptionsPopup';
import { ComboBoxOption } from '../controls/ComboBox';

export function storeSelection(page: string, type: ComboBoxOption | null) {
  localStorage.setItem(page, JSON.stringify(type));
}

export function storeIncludeProxy(page: string, type: boolean) {
  localStorage.setItem(page, JSON.stringify(type));
}

export function storeRoleSelections(page: string, type: ComboBoxOption[] | null) {
  localStorage.setItem(page, JSON.stringify(type));
}

export function storeAutoScrollSettinga(value: AutoScrollSettings) {
  localStorage.setItem('autoScrollSettings', JSON.stringify(value));
}

export function getStoredSelection(page: string) {
  const storedValue = localStorage.getItem(page);

  if (storedValue === null) {
    return null;
  }

  return JSON.parse(storedValue);
}

export function getStoredProxySelection(page: string) {
  const storedValue = localStorage.getItem(page);

  if (storedValue === null) {
    return true;
  }

  return JSON.parse(storedValue);
}

export function getStoredAutoScrollSettings() {
  const storedValue = localStorage.getItem('autoScrollSettings');

  if (storedValue === null) {
    return {
      autoScrollEnabled: true,
      scrollDelay: Number(5),
      scrollIncrement: Number(150),
    } as AutoScrollSettings;
  }

  return JSON.parse(storedValue);
}
